import * as React from "react"
import { Avatar, Box, Flex, Heading, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react"

import { useDocumentTitle } from "../lib/hooks/useDocumentTitle"
import { TOPBAR_HEIGHT } from "../lib/config"

import { useOrgs } from "../components/providers/OrgProvider"
import { SettingsTab } from "../components/SettingsTab"
import { DisplaySettings } from "../components/DisplaySettings"

export const OrgSettings = () => {
  useDocumentTitle("Settings")
  const { currentOrgs } = useOrgs()

  return (
    <Box h="100%" overflowY="scroll" pb={4}>
      <Flex px={6} justify="space-between" align="center" h={TOPBAR_HEIGHT}>
        <Heading as="h3" color="gray.700">
          Settings
        </Heading>
      </Flex>
      <Box px={6}>
        <DisplaySettings />

        {currentOrgs.length > 1 ? (
          <Tabs>
            <TabList>
              {currentOrgs.map((organization) => (
                <Tab key={organization.name} _focus={{ outline: "none" }}>
                  <Avatar mr={2} name={organization.name} src={organization.icon} size="xs" />
                  {organization.name}
                </Tab>
              ))}
            </TabList>

            <TabPanels>
              {currentOrgs.map((organization) => (
                <TabPanel key={organization.uuid} _focus={{ outline: "none" }}>
                  <SettingsTab organization={organization} />
                </TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        ) : (
          <SettingsTab organization={currentOrgs[0]} />
        )}
      </Box>
    </Box>
  )
}
